<panel width="400">
  <h1>{{ reason.id ? reason.name : ('reason.create-headline' | translate) }}</h1>
  @if (!selectReasonCategories) {
    <skeletons [defaultSkeletons]="3" />
  }
  @if (selectReasonCategories) {
    <section scrollable>
      <custom-input [label]="'reason.name' | translate"
        [placeholder]="'reason.name-placeholder' | translate"
        [(value)]="reason.name"
      [required]="true"></custom-input>
      <custom-select [label]="'reason.list-reason-categories' | translate"
        [selectList]="selectReasonCategories"
        [(value)]="selectedReasonCategoryId"
      [required]="false"></custom-select>
      @for (type of types; track type) {
        <custom-input
          [inputType]="inputType.Switch"
          [(value)]="type.enabled"
        [label]="('reason.type.' + type.key) | translate"> </custom-input>
      }
      @if (objectionType!.enabled) {
        <custom-input
          [inputType]="inputType.Switch"
          [(value)]="setOnHold"
        [label]="'reason.type.objection.set-onhold' | translate">  </custom-input>
      }
    </section>
  }
  @if (selectReasonCategories) {
    <section>
      <button #saveButton confirm (click)="save()">{{ 'general.save' | translate }}</button>
    </section>
  }
</panel>
